module.exports = __webpack_public_path__ + "img/creator-1.ff87c1c2.png";